var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'reflect-metadata';
import 'styles/main.scss';
import JobillaSpaApplication from 'common/JobillaSpaApplication';
import { AppEvents } from 'framework/core/events/AppEvents';
import APP_EVENTS_ACTIONS from 'common/events/AppEventsActions';
import MainApp from './PublicApp.vue';
import { JobillaApplication } from 'packages/core/JobillaApplication';
import store from '../../../store/public';
import { DomainEntityType } from 'packages/utilities/domains';
import PageNotFound from '../../../ui/v1/pages/PageNotFound.vue';
import { QuillScope } from 'packages/core/DeltaRenderer';
import env from 'config/env';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import axios from 'axios';
Vue.use(VueMeta);
// Views
// wotan-disable
var LandingPageView = function () { return import(/* webpackChunkName: "job-list-views" */ './views/LandingPageView.vue'); };
var JobListView = function () { return import(/* webpackChunkName: "job-list-views" */ './views/JobListView.vue'); };
var BotView = function () { return import('./views/BotView.vue'); };
// wotan-enable
// Add the actions available
AppEvents.actionList = APP_EVENTS_ACTIONS;
var app = new JobillaSpaApplication(false);
app.appName = 'public_app';
app.withStore(store);
app.languageService.setAppType('spa-public');
axios.defaults.baseURL = env.JOBILLA_API_ROOT;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
// Map the settings app to the main app component in index.html
app.registerComponents({
    MainApp: MainApp,
});
var defaultRoutes = [
    {
        path: '/bot/:botId',
        name: 'ShowBot',
        props: function (route) { return ({ botId: route.params.botId }); },
        component: BotView,
    },
    {
        path: '/job-lists/:listId',
        name: 'Index',
        component: JobListView,
        props: function (route) { return ({ jobListId: route.params.listId }); },
    },
    {
        path: '/job-lists/:listId/:stringIdentifier-:slug',
        name: 'JobList.LandingPage',
        component: LandingPageView,
    },
    {
        path: '/landing-pages/:stringIdentifier-:slug',
        name: 'LandingPage',
        component: LandingPageView,
    },
    {
        path: '*',
        component: PageNotFound,
    },
];
var jobListDomainRoutes = [
    {
        path: '/',
        name: 'Index',
        component: JobListView,
    },
    {
        path: '/:stringIdentifier-:slug',
        name: 'JobList.LandingPage',
        component: LandingPageView,
    },
    {
        path: '*',
        component: PageNotFound,
    },
];
app.configureRoutes([]);
app.start(false);
app.router.onReady(function () { return __awaiter(void 0, void 0, void 0, function () {
    var publicDomain;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                publicDomain = new URL(env.APPS.PUBLIC.URL);
                if (window.location.hostname === publicDomain.hostname) {
                    app.router.addRoutes(defaultRoutes);
                    return [2 /*return*/];
                }
                return [4 /*yield*/, store.dispatch('getEntityByDomain', window.location.hostname)];
            case 1:
                _a.sent();
                if (store.state.entityType === DomainEntityType.JOB_LIST) {
                    app.router.addRoutes(jobListDomainRoutes);
                }
                else {
                    app.router.addRoutes(defaultRoutes);
                }
                return [2 /*return*/];
        }
    });
}); });
new JobillaApplication().boot({
    quillScope: QuillScope.PUBLIC,
    withIntercom: false,
});
